import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { FiestaProvider } from "@pinatagrams/fiesta";

import { router } from "./router";
import { useAuthStore } from "./stores/auth";
import { RealtimeWrapper } from "./stores/realtime";
import { installSessionRefreshFetchInterceptor } from "./utils/session-fetch";
import "@pinatagrams/fiesta/styles.css";
import "./styled-system/styles.css";
import "./styles/global.css";

installSessionRefreshFetchInterceptor();

// Check auth immediately on app bootstrap (before showing any UI)
useAuthStore.getState().checkAuth();

/**
 * Create a QueryClient instance for TanStack Query
 * Configured with default options for all queries and mutations
 */
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000, // 5 minutes
			gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
			retry: 1,
			refetchOnWindowFocus: false,
		},
		mutations: {
			retry: 0,
		},
	},
});

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<FiestaProvider>
				<RealtimeWrapper>
					<RouterProvider router={router} />
				</RealtimeWrapper>
				{/* <ReactQueryDevtools initialIsOpen={true} /> */}
			</FiestaProvider>
		</QueryClientProvider>
	</StrictMode>,
);
